import { render, staticRenderFns } from "./ManageDetail.vue?vue&type=template&id=2d39286d&scoped=true"
import script from "./ManageDetail.vue?vue&type=script&lang=js"
export * from "./ManageDetail.vue?vue&type=script&lang=js"
import style0 from "./ManageDetail.vue?vue&type=style&index=0&id=2d39286d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d39286d",
  null
  
)

export default component.exports